import { render, staticRenderFns } from "./stockByProductionYears.vue?vue&type=template&id=59e21aac&scoped=true&"
import script from "./stockByProductionYears.vue?vue&type=script&lang=js&"
export * from "./stockByProductionYears.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e21aac",
  null
  
)

export default component.exports